import { CARD_BACKGROUND_TYPE, DISPLAY_LEVEL_DOWNGRADE_LOGIC, DISPLAY_LEVEL_RENEWAL_LOGIC, LEVEL_DOWNGRADE_LOGIC, LEVEL_RENEWAL_LOGIC, MEMBERSHIP_PERIOD_MODE, noShopify, noWebapp } from "config/CustomEnums";
import { LevelErrorHandleFields } from "./LevelErrorHandle";

const hexRex = /^[0-9A-Fa-f]{6}$/;

export const createLevelStepOneValidate = ({
  getValues,
  setError,
  clearErrors
}) => {
  clearErrors([
    "translations.en.levelName",
    "displayForegroundElementColor",
    "displayMembershipCardBackgroundColor",
    "cardLandscapeBackgroundImageInApp",
    "cardPortraitBackgroundImageInApp",
    "cardLandscapeBackgroundImageInWeb",
    "cardPortraitBackgroundImageInWeb",
  ]);
  const [
    levelName,
    displayForegroundElementColor,
    membershipCardBackgroundType,
    displayMembershipCardBackgroundColor,
    cardLandscapeBackgroundImageInApp,
    cardPortraitBackgroundImageInApp,
    cardLandscapeBackgroundImageInWeb,
    cardPortraitBackgroundImageInWeb,
    levelBenefits,
  ] = getValues([
    "translations.en.levelName",
    "displayForegroundElementColor",
    "membershipCardBackgroundType",
    "displayMembershipCardBackgroundColor",
    "cardLandscapeBackgroundImageInApp",
    "cardPortraitBackgroundImageInApp",
    "cardLandscapeBackgroundImageInWeb",
    "cardPortraitBackgroundImageInWeb",
    "levelBenefits",
  ]);

  let isValid = true;

  if (!levelName) {
    isValid = false;
    setError(
      "translations.en.levelName",
      {
        type: 'require',
        message: LevelErrorHandleFields.name,
      },
    );
  }

  if (!displayForegroundElementColor || !hexRex.test(displayForegroundElementColor)) {
    isValid = false;
    setError(
      "displayForegroundElementColor",
      {
        type: 'require',
        message: LevelErrorHandleFields.color,
      },
    );
  }
  if (membershipCardBackgroundType === CARD_BACKGROUND_TYPE.image) {
    [
      { name: "cardLandscapeBackgroundImageInApp", value: cardLandscapeBackgroundImageInApp },
      { name: "cardPortraitBackgroundImageInApp", value: cardPortraitBackgroundImageInApp },
      ...(noShopify && noWebapp ? [] : [
        { name: "cardLandscapeBackgroundImageInWeb", value: cardLandscapeBackgroundImageInWeb },
        { name: "cardPortraitBackgroundImageInWeb", value: cardPortraitBackgroundImageInWeb }
      ])
    ].forEach(item => {
      if (!item.value) {
        isValid = false;
        setError(
          item.name,
          {
            type: 'require',
            message: LevelErrorHandleFields.image,
          },
        );
      }
    })
  }
  else {
    if (!displayMembershipCardBackgroundColor || !hexRex.test(displayMembershipCardBackgroundColor)) {
      isValid = false;
      setError(
        "displayMembershipCardBackgroundColor",
        {
          type: 'require',
          message: LevelErrorHandleFields.color,
        },
      );
    }
  }

  const levelBenefitsLength = levelBenefits?.length;
  for (let index = 0; index < levelBenefitsLength; index++) {
    const titleField = `levelBenefits.[${index}].translations.en.title`;
    const contentField = `levelBenefits.[${index}].translations.en.content`;

    clearErrors([
      contentField
    ]);

    const [
      title,
      content,
    ] = getValues([
      titleField,
      contentField
    ]);

    if (!title || !content) {
      isValid = false;
      setError(
        contentField,
        {
          type: 'require',
          message: LevelErrorHandleFields.titleAndContent,
        },
      );
    }
  }

  return isValid;
};


export const createLevelStepTwoValidate = ({
  getValues,
  setError,
  clearErrors,
  levelList,
  levelGlobalSetting,
}) => {
  console.log("@@109", levelList, levelGlobalSetting)

  clearErrors([
    "isLowestLevel",
    "levelRank",
    "enableCheckTargetTotalPointsEarned",
    "targetTotalPointsEarned",
    "accumulatedSpendingInThePeriod",
    "accumulatedSpendingInXDay",
    "spendingInOnePurchase",
    "displayRenewalLogic",
    "enableCheckCalculationSourceValueWithinPeriodForRetain",
    "retainRequiredValue",
    "requiredTransactionTimes",
    "minimumAmountOfOneTransactionForRenew",
    "displayDowngradeLogic",
    "dropdownDowngradeLevel",
  ]);
  const [
    pk,
    isLowestLevel,
    levelRank,
    enableCheckTargetTotalPointsEarned,
    targetTotalPointsEarned,
    enableCheckAccumulatedSpendingInAPeriod,
    accumulatedSpendingInThePeriod,
    accumulatedSpendingInXDay,
    enableCheckSpendingInOnePurchase,
    spendingInOnePurchase,
    displayRenewalLogic,
    enableCheckCalculationSourceValueWithinPeriodForRetain,
    retainRequiredValue,
    enableCheckEffectiveTransactionTimesWithinPeriod,
    requiredTransactionTimes,
    minimumAmountOfOneTransactionForRenew,
    displayDowngradeLogic,
    dropdownDowngradeLevel,
  ] = getValues([
    "pk",
    "isLowestLevel",
    "levelRank",
    "enableCheckTargetTotalPointsEarned",
    "targetTotalPointsEarned",
    "enableCheckAccumulatedSpendingInAPeriod",
    "accumulatedSpendingInThePeriod",
    "accumulatedSpendingInXDay",
    "enableCheckSpendingInOnePurchase",
    "spendingInOnePurchase",
    "displayRenewalLogic",
    "enableCheckCalculationSourceValueWithinPeriodForRetain",
    "retainRequiredValue",
    "enableCheckEffectiveTransactionTimesWithinPeriod",
    "requiredTransactionTimes",
    "minimumAmountOfOneTransactionForRenew",
    "displayDowngradeLogic",
    "dropdownDowngradeLevel",
  ]);

  const activeLevelList = levelList?.filter(item => item.active && item.pk != pk);

  let isValid = true;
  if (isLowestLevel && activeLevelList?.find(item => item.isLowestLevel)) {
    isValid = false;
    setError(
      "isLowestLevel",
      {
        type: 'require',
        message: LevelErrorHandleFields.levelExists,
      },
    );
  };

  if (!levelRank || levelRank < 0) {
    isValid = false;
    setError(
      "levelRank",
      {
        type: 'require',
        message: LevelErrorHandleFields.number,
      },
    );
  }

  if (levelRank && activeLevelList?.find(item => item.levelRank == levelRank)) {
    isValid = false;
    setError(
      "levelRank",
      {
        type: 'require',
        message: LevelErrorHandleFields.levelExists,
      },
    );
  }

  if (!enableCheckTargetTotalPointsEarned && !enableCheckAccumulatedSpendingInAPeriod && !enableCheckSpendingInOnePurchase) {
    isValid = false;
    setError(
      "enableCheckTargetTotalPointsEarned",
      {
        type: 'require',
        message: LevelErrorHandleFields.noCondition,
      },
    );
  }


  if (enableCheckTargetTotalPointsEarned) {
    const lowerLevel = activeLevelList?.find(item => item.levelRank < levelRank && item.enableCheckTargetTotalPointsEarned);
    const higherLevel = activeLevelList?.findLast(item => item.levelRank > levelRank && item.enableCheckTargetTotalPointsEarned);

    const totalValue = parseInt(targetTotalPointsEarned || 0);
    const lowerLevelValue = parseInt(lowerLevel?.targetTotalPointsEarned || 0);
    const higherLevelValue = parseInt(higherLevel?.targetTotalPointsEarned || 0);

    if (!targetTotalPointsEarned && targetTotalPointsEarned != 0) {
      isValid = false;
      setError(
        "targetTotalPointsEarned",
        {
          type: 'require',
          message: LevelErrorHandleFields.conditionField,
        },
      );
    }
    else if (
      lowerLevel
      && higherLevel
      && (
        lowerLevelValue >= totalValue
        || higherLevelValue <= totalValue
      )
    ) {
      isValid = false;
      setError(
        "targetTotalPointsEarned",
        {
          type: 'require',
          message: `The value has to be greater than ${lowerLevelValue} and smaller than ${higherLevelValue}.`,
        },
      );
    }
    else if (
      lowerLevel
      && !higherLevel
      && lowerLevelValue >= totalValue
    ) {
      isValid = false;
      setError(
        "targetTotalPointsEarned",
        {
          type: 'require',
          message: `The value has to be greater than ${lowerLevelValue}.`,
        },
      );
    }
  }

  if (enableCheckAccumulatedSpendingInAPeriod) {
    const lowerLevel = activeLevelList?.find(item => (
      item.levelRank < levelRank
      && item.enableCheckAccumulatedSpendingInAPeriod
      && item.accumulatedSpendingInXDay == accumulatedSpendingInXDay
    ));
    const higherLevel = activeLevelList?.findLast(item => (
      item.levelRank > levelRank
      && item.enableCheckAccumulatedSpendingInAPeriod
      && item.accumulatedSpendingInXDay == accumulatedSpendingInXDay
    ));

    const value = parseInt(accumulatedSpendingInThePeriod || 0);
    const days = parseInt(accumulatedSpendingInXDay || 0);
    const lowerLevelValue = parseInt(lowerLevel?.accumulatedSpendingInThePeriod || 0);
    const higherLevelValue = parseInt(higherLevel?.accumulatedSpendingInThePeriod || 0);

    if (!value || !days) {
      isValid = false;
      setError(
        "accumulatedSpendingInThePeriod",
        {
          type: 'require',
          message: LevelErrorHandleFields.conditionField,
        },
      );
    }
    else if (value < 0 || days < 0) {
      isValid = false;
      setError(
        "accumulatedSpendingInThePeriod",
        {
          type: 'require',
          message: LevelErrorHandleFields.number,
        },
      );
    }
    else if (
      levelGlobalSetting?.membershipPeriodMode === MEMBERSHIP_PERIOD_MODE.dynamic
      && days > parseInt(levelGlobalSetting?.dynamicDuration || 0)
    ) {
      isValid = false;
      setError(
        "accumulatedSpendingInThePeriod",
        {
          type: 'require',
          message: `The period cannot be longer than ${parseInt(levelGlobalSetting?.dynamicDuration || 0)} days.`,
        },
      );
    }
    else if (
      lowerLevel
      && higherLevel
      && (
        lowerLevelValue >= value
        || higherLevelValue <= value
      )
    ) {
      isValid = false;
      setError(
        "accumulatedSpendingInThePeriod",
        {
          type: 'require',
          message: `The value has to be greater than ${lowerLevelValue} and smaller than ${higherLevelValue}.`,
        },
      );
    }
    else if (
      lowerLevel
      && !higherLevel
      && lowerLevelValue >= value
    ) {
      isValid = false;
      setError(
        "accumulatedSpendingInThePeriod",
        {
          type: 'require',
          message: `The value has to be greater than ${lowerLevelValue}.`,
        },
      );
    }
  }

  if (enableCheckSpendingInOnePurchase) {
    const lowerLevel = activeLevelList?.find(item => (
      item.levelRank < levelRank
      && item.enableCheckSpendingInOnePurchase
    ));
    const higherLevel = activeLevelList?.findLast(item => (
      item.levelRank > levelRank
      && item.enableCheckSpendingInOnePurchase
    ));

    const value = parseInt(spendingInOnePurchase || 0);
    const lowerLevelValue = parseInt(lowerLevel?.spendingInOnePurchase || 0);
    const higherLevelValue = parseInt(higherLevel?.spendingInOnePurchase || 0);

    if (!value) {
      isValid = false;
      setError(
        "spendingInOnePurchase",
        {
          type: 'require',
          message: LevelErrorHandleFields.conditionField,
        },
      );
    }
    else if (value < 0) {
      isValid = false;
      setError(
        "spendingInOnePurchase",
        {
          type: 'require',
          message: LevelErrorHandleFields.number,
        },
      );
    }
    else if (
      lowerLevel
      && higherLevel
      && (
        lowerLevelValue >= value
        || higherLevelValue <= value
      )
    ) {
      isValid = false;
      setError(
        "spendingInOnePurchase",
        {
          type: 'require',
          message: `The value has to be greater than ${lowerLevelValue} and smaller than ${higherLevelValue}.`,
        },
      );
    }
    else if (
      lowerLevel
      && !higherLevel
      && lowerLevelValue >= value
    ) {
      isValid = false;
      setError(
        "spendingInOnePurchase",
        {
          type: 'require',
          message: `The value has to be greater than ${lowerLevelValue}.`,
        },
      );
    }
  }

  if (!displayRenewalLogic) {
    isValid = false;
    setError(
      "displayRenewalLogic",
      {
        type: 'require',
        message: LevelErrorHandleFields.renewalLogic,
      },
    );
  }

  if (
    displayRenewalLogic === DISPLAY_LEVEL_RENEWAL_LOGIC[LEVEL_RENEWAL_LOGIC.forceDowngrade]
    && !dropdownDowngradeLevel?.value?.pk
  ) {
    isValid = false;
    setError(
      "dropdownDowngradeLevel",
      {
        type: 'require',
        message: LevelErrorHandleFields.level,
      },
    );
  }

  if (displayRenewalLogic === DISPLAY_LEVEL_RENEWAL_LOGIC[LEVEL_RENEWAL_LOGIC.checkRetainRequirement]) {
    if (!enableCheckCalculationSourceValueWithinPeriodForRetain && !enableCheckEffectiveTransactionTimesWithinPeriod) {
      isValid = false;
      setError(
        "enableCheckCalculationSourceValueWithinPeriodForRetain",
        {
          type: 'require',
          message: LevelErrorHandleFields.noCondition,
        },
      );
    }

    if (enableCheckCalculationSourceValueWithinPeriodForRetain) {
      const value = parseInt(retainRequiredValue || 0);
      if (!value) {
        isValid = false;
        setError(
          "retainRequiredValue",
          {
            type: 'require',
            message: LevelErrorHandleFields.conditionField,
          },
        );
      }
      else if (value < 0) {
        isValid = false;
        setError(
          "retainRequiredValue",
          {
            type: 'require',
            message: LevelErrorHandleFields.number,
          },
        );
      }
    }

    if (enableCheckEffectiveTransactionTimesWithinPeriod) {
      const times = parseInt(requiredTransactionTimes || 0);
      const value = parseInt(minimumAmountOfOneTransactionForRenew || 0);
      if (!value || !times) {
        isValid = false;
        setError(
          "requiredTransactionTimes",
          {
            type: 'require',
            message: LevelErrorHandleFields.conditionField,
          },
        );
      }
      else if (value < 0 || times < 0) {
        isValid = false;
        setError(
          "requiredTransactionTimes",
          {
            type: 'require',
            message: LevelErrorHandleFields.number,
          },
        );
      }
    }

    if (!displayDowngradeLogic) {
        isValid = false;
        setError(
          "displayDowngradeLogic",
          {
            type: 'require',
            message: LevelErrorHandleFields.downgradeLogic,
          },
        );
    } else if (displayDowngradeLogic === DISPLAY_LEVEL_DOWNGRADE_LOGIC[LEVEL_DOWNGRADE_LOGIC.downgradeToSpecificLevel]) {
      if (!dropdownDowngradeLevel?.value?.pk) {
        isValid = false;
        setError(
          "dropdownDowngradeLevel",
          {
            type: 'require',
            message: LevelErrorHandleFields.level,
          },
        );
      }
    } else if (displayDowngradeLogic === DISPLAY_LEVEL_DOWNGRADE_LOGIC[LEVEL_DOWNGRADE_LOGIC.checkEntryRequirements]) {
      if (activeLevelList?.find(item => !item.enableCheckTargetTotalPointsEarned && item.levelRank < levelRank)) {
        isValid = false;
        setError(
          "displayDowngradeLogic",
          {
            type: 'require',
            message: LevelErrorHandleFields.downgradeCheckConditionOne,
          },
        );
      }
    }
  }

  return isValid;
};
